/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Skeleton from "./Skeleton";

const StyledCalendarDaySkeleton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;

  ${({ theme }) => theme.containerMedia.sm} {
    padding: 0.375rem;
  }
`;

const CalendarDaysSkeleton = ({ count = 7 }) => {
  const skeletons = Array(count).fill(null);

  return (
    <>
      {skeletons.map((_, index) => (
        <StyledCalendarDaySkeleton key={index}>
          <Skeleton width="2rem" height="2rem" borderRadius={4} />
        </StyledCalendarDaySkeleton>
      ))}
    </>
  );
};

export default CalendarDaysSkeleton;
